document.addEventListener("DOMContentLoaded", () => {
window.allMetaobjects = [];


async function fetchAllMetaobjects() {
  let endCursor = null;
  let hasNextPage = true;

  while (hasNextPage) {
    const query = `
      {
        metaobjects(type: "discount_code", first: 50${endCursor ? `, after: "${endCursor}"` : ''}) {
          edges {
            node {
              id
              type
              fields {
                key
                value
              }
            }
            cursor
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`;
// 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
    const response = await fetch('/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'e96fa3375c4cd7d8a77ead2f8e48ea58'
      },
      body: JSON.stringify({ query })
    });

    const json = await response.json();
    const data = json.data.metaobjects;
    const metaobjects = data.edges.map(edge => edge.node);

    allMetaobjects.push(...metaobjects); // store all in one array

    hasNextPage = data.pageInfo.hasNextPage;
    endCursor = data.pageInfo.endCursor;
  }

  // console.log('Total metaobjects fetched:', allMetaobjects.length);
  return allMetaobjects;
}

fetchAllMetaobjects().then(all => {
  // console.log(all); // full array of metaobjects with all fields
});



//  $("#sticky_addtocart").click(function () {
//     $(this).attr("disabled", true);
    
//     $('.add-to-cart-text-sticky').addClass('hidden');
//     $('.add-to-cart-text--added-sticky').removeClass('hidden');
//       $(".add-to-cart-button").click();
    
//     setTimeout(function () {
//       $('.add-to-cart-text-sticky').removeClass('hidden');
//       $('.add-to-cart-text--added-sticky').addClass('hidden');
//       $("#sticky_addtocart").attr("disabled", false);
//     }, 1000);
//   });


      // for sticky add to cart
  function StickyAddtoCart() {

      document.body.classList.toggle('sticky-header-mobile', window.scrollY >= 50);
    const mainproductsection = document.querySelector(".product-information");
    if(!mainproductsection)
    { 
      return;
    }
    const offsetTop = mainproductsection.offsetTop;
    const divHeight = mainproductsection.offsetHeight;
    const offsetBottom = offsetTop + divHeight - 400;
    const stickyAddtoDiv = document.querySelector(".variant--bottom");
    if (window.scrollY >= offsetBottom) {
      stickyAddtoDiv.classList.remove("hidden");
        document.body.classList.add('sticky-pdp');

    } else {
      stickyAddtoDiv.classList.add("hidden");
              document.body.classList.remove('sticky-pdp');

    }
   
    const isMobile = window.innerWidth <= 768;
    const scrollThreshold = 1600;
    if (isMobile) {
  if (window.scrollY >= 1200) {
        // stickyAddtoDiv.classList.remove("hidden");
        document.body.classList.add('sticky-pdp');
      } else {
        // stickyAddtoDiv.classList.add("hidden");
                document.body.classList.remove('sticky-pdp');

      }
    }
    // hide sticky add to cart when it reahces button
    const scrolledTo = window.scrollY + window.innerHeight;
    const isReachBottom = document.body.scrollHeight === scrolledTo;
    if (isReachBottom) {
      stickyAddtoDiv.classList.add("hidden");
    }
  }
  // Add event listener for scroll
  window.addEventListener("scroll", StickyAddtoCart);




$('.rating-wrapper').on('click', function () {
  const target = document.querySelector('.gw-rv-main-widget-placeholder');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
});


$('.review-accordian').on('click', function () {
  const target = document.querySelector('.gw-rv-main-widget-placeholder');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
});



document.addEventListener('click', function (e) {
  const btn = e.target.closest('#removed_delivery_not_matching_btn');
  if (btn) {
    removeAllUnmatchedProducts();
  }

  const recipeaddtocart = e.target.closest('.addtocartbuttonarticle')
});



// remove All Unmatched Products
function removeAllUnmatchedProducts() {
  // Retrieve the variant IDs from the data-variantid attribute of <tr> elements
  var variantIDs = $("tbody.ungrouped-product-item-container .cart-item")
    .map(function () {
      return $(this).data("variantid");
    })
    .get();
  // Remove the cart items based on the variant IDs
  removeItemsFromCart(variantIDs);
}

// Function to remove cart items based on variant IDs
function removeItemsFromCart(items) {
  // Get the cart URL.
  var cartUrl = window.Shopify.routes.cart;

  // Create the data object.
  var data = {
    updates: {},
  };

  // Loop through the items and add them to the data object.
  for (var i = 0; i < items.length; i++) {
    data.updates[items[i]] = 0;
  }

  // Make the Ajax request.
  $.ajax({
    type: "POST",
    url: cartUrl,
    data: data,
    dataType: "json",
    success: function (response) {
      window.location.reload();
    },
    error: function (error) {
      // An error occurred.
      alert("An error occurred. Please reload the page ");
    },
  });
}



// Buy all available button
$('#recipe-ingredient-buy-all').click(function (e) {
  e.preventDefault();
  let itemArray = [];
  $('input[name="id"].product-selected-input').each(function () {
    var data_available = $(this).attr('data-available');
    var dataSource = $(this).attr('data-source');
    if (data_available == 'true') {
      var obj = {
        id: parseInt($(this).val()),
        quantity: 1,
      };
      if (dataSource) obj.properties = { _source: dataSource };
      itemArray.push(obj);
    }
  });

  if (itemArray.length > 0) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemArray }),
    })
      .then(() => location.reload()) // reload instead of redirect
      .catch((error) => console.error('Error:', error));
  } else {
    alert('All products sold out.');
  }
});





  if (window.location.href.indexOf('?item_added') > -1) showCartDrawer();

  function showCartDrawer() {
    $('cart-drawer').addClass('active');
    $('#recipe-ingredient-buy-all').text('Added To Cart').addClass('disabled');
    $('body').addClass('cart-drawer-active');
    var newUrl = window.location.href.replace('?item_added', '');
    history.replaceState({}, document.title, newUrl);
  }

  // Rating stars
  const stars = document.querySelectorAll('.stars i');
  const recipeBox = document.getElementById('rk-recipe-box');
  if (recipeBox) {
    const recipeId = recipeBox.getAttribute('data-recipe-id');
    const isCustomer = recipeBox.getAttribute('data-customer');
    if (stars && isCustomer == 'true') {
      stars.forEach((star, i) => {
        star.addEventListener('click', (e) => {
          stars.forEach((s, j) => {
            j <= i ? s.classList.add('active') : s.classList.remove('active');
          });
          const userRating = parseInt(e.target.getAttribute('data-index'));
          fetch('https://my.recipekit.app/rating', {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify({ recipe_id: parseInt(recipeId), user_rating: userRating }),
          })
            .then(() => ($('#rk_rating_thanks').text('Thanks for rating!')))
            .catch(() => $('#rk_rating_thanks').text('Thanks for rating!'));
        });
      });
    }
  }

  // Add single product
const recipeaddtocartbuttonAll = document.querySelectorAll('.addtocartbuttonarticle');
if(recipeaddtocartbuttonAll){ 
recipeaddtocartbuttonAll.forEach(recipeaddtocartbutton => {
  if (recipeaddtocartbutton) {
recipeaddtocartbutton.addEventListener('click', () => {
const variantId = Number(recipeaddtocartbutton.getAttribute('data-product-id'));
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ id: variantId, quantity: 1 }),
})
.then((r) => r.json())
.then(() => {
location.reload();
})
.catch((err) => console.error('Error adding to cart', err));
});
}
});
}


  // Remove button
  $('.remove-button-icon').click(function (e) {
    e.preventDefault();
    var prevSibling = $(this).prevAll('button:first');
    prevSibling.addClass('loading');
    var productid = $(this).attr('data-productId');
    var variantId = $(this).attr('data-variant-id');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { id: parseFloat(variantId), quantity: 0 },
    }).then(() => {
      prevSibling.find('.add_to_cart_label').text('Add To Basket');
      prevSibling.prop('disabled', false);
      $(this).addClass('hide-field');
      var selectElement = $("select[data-productId='" + productid + "']");
      if (selectElement) {
        selectElement.find(`option[value='` + variantId + `']`).attr('data-added', 'No');
      }
    });
  });


window.addEventListener('scroll', () => {
  const all_link_tags = document.querySelectorAll('.menu-list__link');
  const hasExpanded = Array.from(all_link_tags).some(el => el.getAttribute('aria-expanded') === 'true');

  // Smooth scroll effect for header
  const scrollTop = window.scrollY;
  const body = document.body;

  if (scrollTop >= 5 && !hasExpanded) {
    body.classList.add('sticky-header', 'attop');
  } 
  else if (scrollTop <= 5 && hasExpanded) {
    body.classList.remove('sticky-header', 'attop');
  } 
  else if (scrollTop >= 5 && hasExpanded) {
    if (body.classList.contains('attop')) {
      body.classList.add('sticky-header');
    } else {
      body.classList.remove('sticky-header');
    }
  } 
  else {
    body.classList.remove('sticky-header');
  }
});
})